import Model from './Model'

export default class FeatureValue extends Model {

    schema() {
        return {
            id: null,
            feature_id: null,
            value: null,
            mf_value: [],
            features_list: [],
            created_at: null,
            updated_at: null,
            shop_id: null,
            editMode: false,
            inlineLoader: false,
            datasEditInline: {},
            title_description: []
        }
    }

    populateEditMode() {
        this.datasEditInline = {
            value: this.value,
            shop_id: this.shop_id,
        }
    }

    setEditMode() {
        this.editMode = true
        this.populateEditMode();
    }

    cancelEditMode() {
        this.editMode = false
    }

    saveEditMode() {
        this.cancelEditMode()
        this.value = this.datasEditInline.value
        this.shop_id = this.datasEditInline.shop_id
        return this.datasEditInline
    }

}
